import * as React from "react";
const SvgInputClose = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-34244149-818d-4cdc-87b1-5e6786a8820d", "data-name": "SmallX", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { id: "uuid-4d6c43f3-1041-4cff-9759-964330343946", "data-name": "vector", d: "m13.8,3.3l-1.2-1.2-4.6,4.7L3.3,2.2l-1.1,1.1,4.6,4.7-4.7,4.7,1.2,1.2,4.7-4.7,4.7,4.7,1.2-1.2-4.7-4.7,4.6-4.7Z", style: {
  fill: "#707676"
} }));
export default SvgInputClose;
